import { ReloadOutlined } from "@ant-design/icons";
import { useQueryClient } from "@tanstack/react-query";

function QueryRetry({
	queryKey,
	refetch,
}: {
	queryKey: any;
	refetch?: () => void;
}) {
	const queryClient = useQueryClient();

	/**
	 * Prefer `refetch()` over `queryClient.refetchQueries({ queryKey })`
	 * `refetch()` is safer and more precise — it only affects that query instance,
	 * `queryClient.refetchQueries` may refetch multiple queries sharing the same key
	 * ⚠️ Make sure to pass the correct queryKey to the refetch function
	 */
	const handleRetry = () => {
		if (refetch) refetch();
		else if (queryKey) queryClient.refetchQueries({ queryKey });
	};

	return (
		<div className="flex flex-col w-full h-full items-center justify-center py-10 text-center text-gray-600">
			<button
				onClick={handleRetry}
				className="p-4 rounded-full transition-all cursor-pointer"
			>
				<ReloadOutlined className="text-3xl hover:rotate-180 transition-transform duration-500" />
			</button>
			<p className="mt-3 text-sm">
				Unable to fetch data. Please refresh or try again.
			</p>
		</div>
	);
}

export default QueryRetry;
